import React, { useState, useEffect } from 'react';
import { 
  Users, 
  User,
  Plus, 
  Search, 
  Filter, 
  Edit, 
  Settings, 
  Trash2, 
  Phone, 
  FileText, 
  Download, 
  Upload, 
  Calendar, 
  Bell, 
  BarChart3,
  Eye,
  Save,
  X,
  Camera,
  UserPlus,
  FileSpreadsheet,
  AlertCircle,
  CheckCircle,
  Clock,
  MapPin,
  GraduationCap,
  Languages,
  DollarSign,
  Briefcase,
  FileUp,
  Scan,
  FileCheck,
  Globe,
  Brain,
  Zap
} from 'lucide-react';
import config from '../config';

const HumanResourcesManagement = () => {
  const [activeTab, setActiveTab] = useState('search');
  const [workers, setWorkers] = useState([]);
  const [professions, setProfessions] = useState([]);
  const [delegates, setDelegates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAddForm, setShowAddForm] = useState(false);
  const [editingWorker, setEditingWorker] = useState(null);
  

  const [selectedImage, setSelectedImage] = useState(null);
const [showImagePreview, setShowImagePreview] = useState(false);


  // حالات البحث والفلترة
  const [searchFilters, setSearchFilters] = useState({
    name: '',
    phone: '',
    profession: '',
    minExperience: '',
    maxExperience: '',
    minAge: '',
    maxAge: '',
    status: '',
    delegate: '',
    qualification: {
  level: '',
  specialization: '',
  details: ''
},    languages: '',
    availability: ''
  });

  // بيانات العامل الجديد
const [newWorker, setNewWorker] = useState({
  name: '',
  birthYear: '', // فارغ بدلاً من 2000
  phones: [''],
  profession: '',
  professionDescription: '', // حقل جديد لوصف المهنة
  previousExperience: [''],
  delegate: '',
  notes: '',
  passportProfession: '',
  license: '',
  address: { governorate: '', city: '' },
  maritalStatus: 'أعزب',
  qualification: {
    level: '',
    specialization: '',
    details: ''
  },
  languages: [],
  experienceYears: 0,
  lastSalary: '',
  requestedSalary: '',
  employmentStatus: 'متاح',
  photo: null,
  cvFile: null
});

  // حالات السيرة الذاتية
  const [cvAnalysis, setCvAnalysis] = useState(null);
  const [analyzingCV, setAnalyzingCV] = useState(false);
  const [analysisProgress, setAnalysisProgress] = useState(0); // أضف هذا السطر
const [analysisStep, setAnalysisStep] = useState(''); // أضف هذا السطر

  const [showCVAnalysis, setShowCVAnalysis] = useState(false);
const [showMiniAnalysis, setShowMiniAnalysis] = useState(false);


const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
const [workerToDelete, setWorkerToDelete] = useState(null);

  const [cvLanguage, setCvLanguage] = useState('ar');

  // المهن المتاحة
  const [availableProfessions, setAvailableProfessions] = useState([]);
  const [showAddProfession, setShowAddProfession] = useState(false);
  const [newProfession, setNewProfession] = useState('');

  // إدارة المؤهلات الدراسية
const [qualificationLevels, setQualificationLevels] = useState([
  { id: 1, name: 'أمي', hasSpecialization: false },
  { id: 2, name: 'يقرأ ويكتب', hasSpecialization: false },
  { id: 3, name: 'ابتدائية', hasSpecialization: false },
  { id: 4, name: 'إعدادية', hasSpecialization: false },
  { id: 5, name: 'ثانوية', hasSpecialization: true },
  { id: 6, name: 'دبلوم', hasSpecialization: true },
  { id: 7, name: 'معهد فني', hasSpecialization: true },
  { id: 8, name: 'جامعي', hasSpecialization: true },
  { id: 9, name: 'دراسات عليا', hasSpecialization: true }
]);

const [qualificationSpecializations, setQualificationSpecializations] = useState({
  'ثانوية': ['ثانوية عامة', 'ثانوية أزهرية', 'ثانوية صناعية', 'ثانوية تجارية', 'ثانوية زراعية'],
  'دبلوم': ['دبلوم صناعي', 'دبلوم تجاري', 'دبلوم زراعي', 'دبلوم فندقي', 'دبلوم صحي'],
  'معهد فني': ['معهد فني صناعي', 'معهد فني تجاري', 'معهد فني زراعي', 'معهد فني صحي'],
  'جامعي': ['كلية الهندسة', 'كلية الطب', 'كلية التجارة', 'كلية الحقوق', 'كلية الآداب', 'كلية العلوم', 'كلية الزراعة', 'كلية التربية'],
  'دراسات عليا': ['ماجستير', 'دكتوراه', 'دبلوم دراسات عليا']
});

const [showQualificationManager, setShowQualificationManager] = useState(false);
const [newQualificationLevel, setNewQualificationLevel] = useState('');
const [editingQualification, setEditingQualification] = useState(null);
const [newSpecialization, setNewSpecialization] = useState('');
  // إعدادات API
// في HumanResourcesManagement.js، استبدل دالة getAPIConfig بهذه:
// استخدم عنوان واحد فقط لكل الخدمات
const getAPIConfig = () => {
  const systemURLs = JSON.parse(localStorage.getItem('systemURLs') || '{}');
  const base = systemURLs.API_BASE_URL || config.API_BASE_URL; // مفيش هاردكود IP

  return {
    humanResourcesAPI: base,
    professionAPI: base,
    delegateAPI: base
  };
};


  // تحميل البيانات الأساسية
useEffect(() => {
  loadInitialData();
  loadQualificationSettings();
}, []);

  const loadInitialData = async () => {
    try {
      setLoading(true);
      await Promise.all([
        loadWorkers(),
        loadProfessions(),
        loadDelegates()
      ]);
    } catch (error) {
      console.error('خطأ في تحميل البيانات:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadWorkers = async () => {
    try {
      const { humanResourcesAPI } = getAPIConfig();
      const response = await fetch(`${humanResourcesAPI}/api/humanresources/workers`);
      if (response.ok) {
        const data = await response.json();
        setWorkers(data.workers || []);
      }
    } catch (error) {
      console.error('خطأ في تحميل العمال:', error);
    }
  };




  // دوال المعاينة والتحميل
const previewCV = (file) => {
  if (file) {
    const url = URL.createObjectURL(file);
    window.open(url, '_blank');
  }
};

const previewImage = (file) => {
  if (file) {
    const url = URL.createObjectURL(file);
    setSelectedImage(url);
  }
};

const downloadFile = (file, type) => {
  if (file) {
    const url = URL.createObjectURL(file);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${type}_${newWorker.name || 'عامل'}_${Date.now()}${file.name.substring(file.name.lastIndexOf('.'))}`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }
};



const loadProfessions = async () => {
  try {
    const { humanResourcesAPI } = getAPIConfig();

    // جلب المهن من نفس السيرفر فقط
    const response = await fetch(`${humanResourcesAPI}/api/humanresources/professions`);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const data = await response.json();

    // ندعم شكلين متوقعين للاستجابة
    // 1) { success: true, professions: [...] }
    // 2) [...] مباشرة
    const list = Array.isArray(data) ? data : (data.professions || []);

    // تطبيع العناصر عشان الواجهة تتعامل مع نفس المفاتيح
    const formatted = list.map((prof, idx) => ({
      id: prof.id ?? prof.ProfessionID ?? idx + 1,
      name: prof.name ?? prof.ProfessionName ?? String(prof),
      ProfessionName: prof.name ?? prof.ProfessionName ?? String(prof)
    }));

    setAvailableProfessions(formatted.length ? formatted : [
      { id: 1, name: 'سائق', ProfessionName: 'سائق' },
      { id: 2, name: 'طباخ', ProfessionName: 'طباخ' },
      { id: 3, name: 'خادمة', ProfessionName: 'خادمة' },
      { id: 4, name: 'عامل بناء', ProfessionName: 'عامل بناء' },
      { id: 5, name: 'كهربائي', ProfessionName: 'كهربائي' }
    ]);
  } catch (error) {
    console.error('خطأ في تحميل المهن:', error);
    //Fallback محلي فقط
    setAvailableProfessions([
      { id: 1, name: 'سائق', ProfessionName: 'سائق' },
      { id: 2, name: 'طباخ', ProfessionName: 'طباخ' },
      { id: 3, name: 'خادمة', ProfessionName: 'خادمة' },
      { id: 4, name: 'عامل بناء', ProfessionName: 'عامل بناء' },
      { id: 5, name: 'كهربائي', ProfessionName: 'كهربائي' }
    ]);
  }
};




const downloadCV = async (workerId, workerName) => {
  try {
    const { humanResourcesAPI } = getAPIConfig();
    const response = await fetch(`${humanResourcesAPI}/api/humanresources/workers/${workerId}/cv`);
    
    if (response.ok) {
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `CV_${workerName}_${new Date().getTime()}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } else {
      alert('لم يتم العثور على السيرة الذاتية لهذا العامل');
    }
  } catch (error) {
    console.error('خطأ في تحميل السيرة الذاتية:', error);
    alert('حدث خطأ في تحميل السيرة الذاتية');
  }
};



const addNewProfession = async () => {
  if (!newProfession.trim()) return;
  
  try {
    const { humanResourcesAPI } = getAPIConfig();
    
    const response = await fetch(`${humanResourcesAPI}/api/humanresources/professions`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ProfessionName: newProfession.trim() })
    });
    
    const result = await response.json();
    
    if (response.ok && result.success) {
      // إضافة المهنة للقائمة
      setAvailableProfessions(prev => [...prev, result.profession]);
      setNewProfession('');
      setShowAddProfession(false);
      alert('تم إضافة المهنة وحفظها بنجاح');
    } else {
      throw new Error(result.message || 'فشل في الإضافة');
    }
  } catch (error) {
    console.error('خطأ في إضافة المهنة:', error);
    
    // إضافة محلية كحل احتياطي
    const newProf = { 
      id: Date.now(), 
      name: newProfession.trim(), 
      ProfessionName: newProfession.trim() 
    };
    setAvailableProfessions(prev => [...prev, newProf]);
    setNewProfession('');
    setShowAddProfession(false);
    alert('تم إضافة المهنة محلياً (لم يتم الحفظ في قاعدة البيانات)');
  }
};

const loadDelegates = async () => {
  try {
    const { humanResourcesAPI } = getAPIConfig();

    // جلب المناديب من نفس السيرفر (بدون أي IPs بديلة)
    const response = await fetch(`${humanResourcesAPI}/api/delegates`);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const data = await response.json();

    // ندعم شكلين محتملين:
    // 1) { success: true, delegates: [...] }
    // 2) [...] مباشرة
    const list = Array.isArray(data) ? data : (data.delegates || data.items || []);

    const formattedDelegates = list.map((d, idx) => ({
      id: d.id ?? d.DelegateID ?? idx + 1,
      name: d.name ?? d.DelegateName ?? 'بدون اسم',
      DelegateName: d.DelegateName ?? d.name ?? 'بدون اسم'
    }));

    setDelegates(formattedDelegates.length ? formattedDelegates : [
      { id: 1, name: 'بدون مندوب', DelegateName: 'بدون مندوب' }
    ]);
  } catch (error) {
    console.error('خطأ في تحميل المناديب:', error);
    setDelegates([
      { id: 1, name: 'بدون مندوب', DelegateName: 'بدون مندوب' }
    ]);
  }
};

// تحميل إعدادات المؤهلات من localStorage
const loadQualificationSettings = () => {
  const savedLevels = localStorage.getItem('qualificationLevels');
  const savedSpecializations = localStorage.getItem('qualificationSpecializations');
  
  if (savedLevels) {
    setQualificationLevels(JSON.parse(savedLevels));
  }
  if (savedSpecializations) {
    setQualificationSpecializations(JSON.parse(savedSpecializations));
  }
};

// حفظ إعدادات المؤهلات في localStorage
const saveQualificationSettings = () => {
  localStorage.setItem('qualificationLevels', JSON.stringify(qualificationLevels));
  localStorage.setItem('qualificationSpecializations', JSON.stringify(qualificationSpecializations));
};

// إضافة مستوى مؤهل جديد
const addQualificationLevel = () => {
  if (!newQualificationLevel.trim()) return;
  
  const newLevel = {
    id: Date.now(),
    name: newQualificationLevel.trim(),
    hasSpecialization: false
  };
  
  setQualificationLevels(prev => [...prev, newLevel]);
  setNewQualificationLevel('');
  saveQualificationSettings();
};

// حذف مستوى مؤهل
const deleteQualificationLevel = (levelId) => {
  const levelToDelete = qualificationLevels.find(level => level.id === levelId);
  if (levelToDelete) {
    setQualificationLevels(prev => prev.filter(level => level.id !== levelId));
    const newSpecializations = { ...qualificationSpecializations };
    delete newSpecializations[levelToDelete.name];
    setQualificationSpecializations(newSpecializations);
    saveQualificationSettings();
  }
};

// تبديل إمكانية التخصص لمستوى معين
const toggleSpecializationOption = (levelId) => {
  setQualificationLevels(prev => prev.map(level => 
    level.id === levelId 
      ? { ...level, hasSpecialization: !level.hasSpecialization }
      : level
  ));
  saveQualificationSettings();
};

// إضافة تخصص جديد لمستوى معين
const addSpecialization = (levelName) => {
  if (!newSpecialization.trim()) return;
  
  setQualificationSpecializations(prev => ({
    ...prev,
    [levelName]: [...(prev[levelName] || []), newSpecialization.trim()]
  }));
  setNewSpecialization('');
  saveQualificationSettings();
};

// حذف تخصص
const deleteSpecialization = (levelName, specializationIndex) => {
  setQualificationSpecializations(prev => ({
    ...prev,
    [levelName]: prev[levelName].filter((_, index) => index !== specializationIndex)
  }));
  saveQualificationSettings();
};

// تحليل السيرة الذاتية
// تحليل السيرة الذاتية
const analyzeCVFile = async (file) => {
  setAnalyzingCV(true);
  setAnalysisProgress(0);
  setAnalysisStep('بدء التحليل...');
  
  try {
    console.log('بدء تحليل الملف:', file.name, 'حجم الملف:', file.size);
    
    // التحقق من حجم الملف
    if (file.size > 10 * 1024 * 1024) {
      throw new Error('حجم الملف كبير جداً. الحد الأقصى 10 ميجابايت');
    }

    // التحقق من نوع الملف
    const allowedTypes = [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'image/jpeg',
      'image/png',
      'image/jpg'
    ];

    if (!allowedTypes.includes(file.type)) {
      throw new Error('نوع الملف غير مدعوم');
    }

    // خطوات التحليل مع التوقيتات
    const steps = [
      { progress: 5, step: 'فحص نوع الملف...', delay: 500 },
      { progress: 15, step: 'تحضير الملف للتحليل...', delay: 1000 },
      { progress: 30, step: 'استخراج النص من الملف...', delay: 2000 },
      { progress: 50, step: 'تحليل البيانات الشخصية...', delay: 1500 },
      { progress: 65, step: 'استخراج المهن والخبرات...', delay: 1500 },
      { progress: 80, step: 'تحليل المؤهلات والمهارات...', delay: 1000 },
      { progress: 95, step: 'إنهاء التحليل...', delay: 500 }
    ];
    
    // تشغيل خطوات التقدم
    let stepIndex = 0;
    const progressInterval = setInterval(() => {
      if (stepIndex < steps.length) {
        setAnalysisProgress(steps[stepIndex].progress);
        setAnalysisStep(steps[stepIndex].step);
        stepIndex++;
      }
    }, 1500); // كل ثانية ونصف

    // إعداد FormData
    const formData = new FormData();
    formData.append('cvFile', file);
    
    const { humanResourcesAPI } = getAPIConfig();
    const apiUrl = `${humanResourcesAPI}/api/humanresources/analyze-cv`;
    
    console.log('إرسال الطلب إلى:', apiUrl);
    
    // إعداد الطلب مع timeout أطول
    const controller = new AbortController();
    const timeoutId = setTimeout(() => {
      clearInterval(progressInterval);
      controller.abort();
    }, 300000); // 2 دقيقة

    const response = await fetch(apiUrl, {
      method: 'POST',
      body: formData,
      signal: controller.signal,
      headers: {
        // لا تضع Content-Type عند استخدام FormData
      }
    });

    clearTimeout(timeoutId);
    clearInterval(progressInterval);
    
    // إكمال التقدم
    setAnalysisProgress(100);
    setAnalysisStep('تم الانتهاء بنجاح!');
    
    console.log('استجابة السيرفر:', response.status, response.statusText);
    
    if (!response.ok) {
      let errorMessage = `خطأ في السيرفر: ${response.status}`;
      try {
        const errorData = await response.json();
        errorMessage = errorData.message || errorMessage;
      } catch (e) {
        console.error('خطأ في قراءة رسالة الخطأ:', e);
      }
      throw new Error(errorMessage);
    }
    
    const result = await response.json();
    console.log('نتيجة التحليل:', result);
    
    if (result.success && result.analysis) {
      setCvAnalysis(result.analysis);
      setShowCVAnalysis(true);
      

      // في نهاية try block بعد setShowCVAnalysis(true)
if (result.success && result.analysis) {
  setCvAnalysis(result.analysis);
  setShowCVAnalysis(true);
  
  // تشغيل صوت تنبيه (اختياري)
  try {
    const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmMcCThR0vbQeSsFJHfH8N2QQAoUXrTp66hVFApGn+DyvmMcCThR0vbQeSsFJHfH8N2QQAoUXrTp66hVFApGn+DyvmMcCThR0vbQeSs=');
    audio.play().catch(() => {}); // تجاهل الأخطاء
  } catch (e) {}
  
  setTimeout(() => {
    alert(`تم تحليل السيرة الذاتية بنجاح!\nالاسم: ${result.analysis.personalInfo?.name || 'غير محدد'}\nالمهنة: ${result.analysis.profession?.current || 'غير محدد'}`);
  }, 1000);
}



      // انتظار ثانية لعرض "تم الانتهاء" قبل إظهار النتيجة
      setTimeout(() => {
        alert(`تم تحليل السيرة الذاتية بنجاح!\nالاسم: ${result.analysis.personalInfo?.name || 'غير محدد'}\nالمهنة: ${result.analysis.profession?.current || 'غير محدد'}`);
      }, 1000);
    } else {
      throw new Error(result.message || 'فشل في تحليل السيرة الذاتية');
    }
    
  } catch (error) {
    console.error('خطأ في تحليل السيرة الذاتية:', error);
    
    let errorMessage = 'فشل في تحليل السيرة الذاتية';
    
    if (error.name === 'AbortError') {
      errorMessage = 'انتهت مهلة الاتصال. الملف كبير أو الاتصال بطيء. الرجاء المحاولة مرة أخرى';
      setAnalysisStep('انتهت مهلة الاتصال');
    } else if (error.message.includes('Failed to fetch')) {
      errorMessage = 'لا يمكن الاتصال بالسيرفر. تأكد من أن السيرفر يعمل والرابط صحيح';
      setAnalysisStep('خطأ في الاتصال');
    } else {
      errorMessage = error.message;
      setAnalysisStep('حدث خطأ');
    }
    
    alert(errorMessage);
  } finally {
    // إعادة تعيين كل شيء بعد 2 ثانية
    setTimeout(() => {
      setAnalyzingCV(false);
      setAnalysisProgress(0);
      setAnalysisStep('');
    }, 2000);
  }
};

// ملء البيانات من تحليل السيرة الذاتية
// تحديث دالة fillDataFromCV في React component
const fillDataFromCV = async () => {
  if (!cvAnalysis) return;
  
  const { personalInfo, address, profession, qualifications, experience, salary } = cvAnalysis;
  
  // ترجمة الاسم إذا كان بالإنجليزية
  let translatedName = personalInfo.name;
  if (personalInfo.name && /[a-zA-Z]/.test(personalInfo.name)) {
    console.log('ترجمة الاسم:', personalInfo.name);
    translatedName = await translateNameWithGemini(personalInfo.name);
    console.log('الاسم المترجم:', translatedName);
  }
  
  setNewWorker(prev => ({
    ...prev,
    name: translatedName || prev.name,
    phones: personalInfo.phone ? [personalInfo.phone, ...prev.phones.filter(p => p !== personalInfo.phone)] : prev.phones,
    profession: profession.current || prev.profession,
    passportProfession: profession.passportProfession || prev.passportProfession,
    
    // إضافة سنة الميلاد
    birthYear: personalInfo.birthDate ? 
      (personalInfo.birthDate.includes('/') ? 
        personalInfo.birthDate.split('/')[2] : // إذا كان التاريخ بصيغة DD/MM/YYYY
        personalInfo.birthDate.includes('-') ?
          personalInfo.birthDate.split('-')[0] : // إذا كان بصيغة YYYY-MM-DD
          personalInfo.birthDate.match(/\d{4}/)?.[0] || prev.birthYear // البحث عن 4 أرقام متتالية
      ) : prev.birthYear,
      
    address: {
      governorate: address.governorate || prev.address.governorate,
      city: address.city || prev.address.city
    },
    maritalStatus: personalInfo.maritalStatus || prev.maritalStatus,
    qualification: qualifications.education || prev.qualification,
    languages: qualifications.languages || prev.languages,
    experienceYears: profession.experienceYears || prev.experienceYears,
    previousExperience: experience.length > 0 ? experience : prev.previousExperience,
    lastSalary: salary.lastSalary || prev.lastSalary,
    requestedSalary: salary.requestedSalary || prev.requestedSalary,
    license: qualifications.licenses?.join(', ') || prev.license,
    skills: cvAnalysis.skills || prev.skills,
    notes: prev.notes // عدم تغيير الملاحظات - تبقى كما هي
  }));
  
  setShowCVAnalysis(false);
  alert('تم ملء البيانات من السيرة الذاتية بنجاح!');
};



// دالة ترجمة الأسماء باستخدام Gemini
const translateNameWithGemini = async (name) => {
  if (!name || typeof name !== 'string' || name.trim().length === 0) {
    return name;
  }
  
  // تحقق إذا كان الاسم يحتاج ترجمة (يحتوي على أحرف إنجليزية)
  const hasEnglish = /[a-zA-Z]/.test(name);
  const hasArabic = /[أ-ي]/.test(name);
  
  if (!hasEnglish || hasArabic) {
    return name; // الاسم عربي أو مختلط
  }
  
  try {
    const { humanResourcesAPI } = getAPIConfig();
    
    const response = await fetch(`${humanResourcesAPI}/api/humanresources/translate-name`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: name })
    });
    
    if (response.ok) {
      const result = await response.json();
      return result.translatedName || name;
    } else {
      console.error('خطأ في ترجمة الاسم');
      return name;
    }
  } catch (error) {
    console.error('خطأ في ترجمة الاسم:', error);
    return name;
  }
};


// رفع ملف السيرة الذاتية
const handleCVUpload = async (event) => {
  const file = event.target.files[0];
  if (!file) return;

  // التحقق من نوع الملف
  const allowedTypes = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'image/jpeg',
    'image/png',
    'image/jpg'
  ];

  if (!allowedTypes.includes(file.type)) {
    alert('نوع الملف غير مدعوم. يرجى اختيار ملف PDF أو Word أو صورة');
    return;
  }

  if (file.size > 10 * 1024 * 1024) { // 10MB
    alert('حجم الملف كبير جداً. الحد الأقصى 10 ميجابايت');
    return;
  }

  setNewWorker(prev => ({ ...prev, cvFile: file }));
  
  // بدء تحليل السيرة الذاتية تلقائياً
  await analyzeCVFile(file);
};

  // إضافة مهنة جديدة


  // إضافة رقم تليفون جديد
  const addPhoneNumber = () => {
    setNewWorker(prev => ({
      ...prev,
      phones: [...prev.phones, '']
    }));
  };

  // إضافة خبرة جديدة
  const addExperience = () => {
    setNewWorker(prev => ({
      ...prev,
      previousExperience: [...prev.previousExperience, '']
    }));
  };

  // تحديث رقم تليفون
  const updatePhone = (index, value) => {
    setNewWorker(prev => {
      const newPhones = [...prev.phones];
      newPhones[index] = value;
      return { ...prev, phones: newPhones };
    });
  };

  // تحديث خبرة
  const updateExperience = (index, value) => {
    setNewWorker(prev => {
      const newExperience = [...prev.previousExperience];
      newExperience[index] = value;
      return { ...prev, previousExperience: newExperience };
    });
  };

  // حذف رقم تليفون
  const removePhone = (index) => {
    if (newWorker.phones.length > 1) {
      setNewWorker(prev => ({
        ...prev,
        phones: prev.phones.filter((_, i) => i !== index)
      }));
    }
  };

  // حذف خبرة
  const removeExperience = (index) => {
    if (newWorker.previousExperience.length > 1) {
      setNewWorker(prev => ({
        ...prev,
        previousExperience: prev.previousExperience.filter((_, i) => i !== index)
      }));
    }
  };

  // حفظ عامل جديد
// حفظ عامل جديد - النسخة المحدثة والموحدة
const saveWorker = async () => {
  try {
    if (!newWorker.name || !newWorker.profession) {
      alert('الرجاء إدخال الاسم والمهنة');
      return;
    }

    setLoading(true);
    const { humanResourcesAPI } = getAPIConfig();
    
    console.log('بدء عملية الحفظ...');
    console.log('API URL:', `${humanResourcesAPI}/api/humanresources/workers`);
    
    // تحويل المؤهل إلى نص واحد
    let qualificationText = '';
    if (typeof newWorker.qualification === 'object') {
      qualificationText = newWorker.qualification.level || '';
      if (newWorker.qualification.specialization) {
        qualificationText += ' - ' + newWorker.qualification.specialization;
      }
      if (newWorker.qualification.details) {
        qualificationText += ' (' + newWorker.qualification.details + ')';
      }
    } else {
      qualificationText = newWorker.qualification || '';
    }

    // إعداد FormData لرفع الملفات
    const formData = new FormData();
    formData.append('WorkerName', newWorker.name);
    formData.append('BirthYear', newWorker.birthYear || '');
    formData.append('Phones', JSON.stringify(newWorker.phones.filter(phone => phone.trim())));
    formData.append('Profession', newWorker.profession);
    formData.append('ProfessionDescription', newWorker.professionDescription || '');
    formData.append('PreviousExperience', JSON.stringify(newWorker.previousExperience.filter(exp => exp.trim())));
    formData.append('DelegateName', newWorker.delegate || '');
    formData.append('Notes', newWorker.notes || '');
    formData.append('PassportProfession', newWorker.passportProfession || '');
    formData.append('License', newWorker.license || '');
    formData.append('Governorate', newWorker.address.governorate || '');
    formData.append('City', newWorker.address.city || '');
    formData.append('MaritalStatus', newWorker.maritalStatus || 'أعزب');
    formData.append('Qualification', qualificationText);
    formData.append('Skills', JSON.stringify(newWorker.skills?.filter(skill => skill.trim()) || []));
    formData.append('ExperienceYears', newWorker.experienceYears || 0);
    formData.append('LastSalary', newWorker.lastSalary || '');
    formData.append('RequestedSalary', newWorker.requestedSalary || '');
    formData.append('EmploymentStatus', newWorker.employmentStatus || 'متاح');

    // إضافة الملفات
    if (newWorker.photo) {
      formData.append('photo', newWorker.photo);
      console.log('تم إضافة الصورة');
    }
    if (newWorker.cvFile) {
      formData.append('cvFile', newWorker.cvFile);
      console.log('تم إضافة السيرة الذاتية');
    }

    console.log('إرسال البيانات...');

    const response = await fetch(`${humanResourcesAPI}/api/humanresources/workers`, {
      method: 'POST',
      body: formData
    });

    console.log('Response status:', response.status);
    console.log('Response headers:', response.headers);

    if (response.ok) {
      const result = await response.json();
      console.log('نتيجة الحفظ:', result);
      
      await loadWorkers();
      resetForm();
      setShowAddForm(false);
      alert('تم حفظ العامل بنجاح');
    } else {
      const errorText = await response.text();
      console.error('خطأ من السيرفر:', response.status, errorText);
      
      let errorData;
      try {
        errorData = JSON.parse(errorText);
      } catch {
        errorData = { message: errorText || 'خطأ غير معروف' };
      }
      
      throw new Error(errorData.message || `خطأ HTTP: ${response.status}`);
    }
  } catch (error) {
    console.error('خطأ كامل في حفظ العامل:', error);
    
    let errorMessage = 'فشل في حفظ العامل: ';
    if (error.message.includes('Failed to fetch')) {
      errorMessage += 'لا يمكن الاتصال بالسيرفر. تأكد من أن السيرفر يعمل على المنفذ 5050.';
    } else if (error.message.includes('500')) {
      errorMessage += 'خطأ في السيرفر. تحقق من logs السيرفر.';
    } else {
      errorMessage += error.message;
    }
    
    alert(errorMessage);
  } finally {
    setLoading(false);
  }
};

  // إعادة تعيين النموذج
// تحديث دالة resetForm
const resetForm = () => {
  // تنظيف URLs المؤقتة
  if (selectedImage && selectedImage.startsWith('blob:')) {
    URL.revokeObjectURL(selectedImage);
  }
  
  setNewWorker({
    name: '',
    birthYear: '',
    phones: [''],
    profession: '',
    professionDescription: '',
    previousExperience: [''],
    delegate: '',
    notes: '',
    passportProfession: '',
    license: '',
    address: { governorate: '', city: '' },
    maritalStatus: 'أعزب',
    qualification: {
      level: '',
      specialization: '',
      details: ''
    },
    languages: [],
    skills: [''], // إضافة المهارات
    experienceYears: 0,
    lastSalary: '',
    requestedSalary: '',
    employmentStatus: 'متاح',
    photo: null,
    cvFile: null
  });
  setCvAnalysis(null);
  setShowCVAnalysis(false);
  setSelectedImage(null);
  setShowImagePreview(false);
};

// دالة فتح نافذة التعديل
const openEditModal = (worker) => {
  setEditingWorker({
    ...worker,
    phones: worker.phones || [''],
    previousExperience: worker.previousExperience || [''],
    skills: worker.skills || [''],
    languages: worker.languages || []
  });
};

// دالة فتح نافذة المعاينة
const [viewingWorker, setViewingWorker] = useState(null);

const openViewModal = (worker) => {
  setViewingWorker(worker);
};

// دالة حذف العامل
// دالة حذف العامل
const deleteWorker = (workerId, workerName) => {
  setWorkerToDelete({ id: workerId, name: workerName });
  setShowDeleteConfirm(true);
};

// دالة تأكيد الحذف
const confirmDelete = async () => {
  if (!workerToDelete) return;

  try {
    setLoading(true);
    const { humanResourcesAPI } = getAPIConfig();
    
    const response = await fetch(`${humanResourcesAPI}/api/humanresources/workers/${workerToDelete.id}`, {
      method: 'DELETE'
    });

    if (response.ok) {
      await loadWorkers();
      alert('تم حذف العامل بنجاح');
    } else {
      throw new Error('فشل في حذف العامل');
    }
  } catch (error) {
    console.error('خطأ في حذف العامل:', error);
    alert('فشل في حذف العامل');
  } finally {
    setLoading(false);
    setShowDeleteConfirm(false);
    setWorkerToDelete(null);
  }
};

  // فلترة العمال
// استبدل دالة filteredWorkers بهذه
const filteredWorkers = workers.filter(worker => {
  // البحث العالمي
  if (searchFilters.globalSearch) {
    const searchTerm = searchFilters.globalSearch.toLowerCase();
    const searchableFields = [
      worker.name,
      worker.profession,
      worker.professionDescription,
      worker.notes,
      worker.passportProfession,
      worker.license,
      worker.qualification,
      worker.delegate,
      worker.governorate,
      worker.city,
      worker.maritalStatus,
      worker.lastSalary,
      worker.requestedSalary,
      ...(worker.phones || []),
      ...(worker.previousExperience || []),
      ...(worker.languages || []),
      ...(worker.skills || [])
    ].join(' ').toLowerCase();
    
    if (!searchableFields.includes(searchTerm)) {
      return false;
    }
  }

  // باقي الفلاتر
  if (searchFilters.name && !worker.name?.toLowerCase().includes(searchFilters.name.toLowerCase())) {
    return false;
  }

  if (searchFilters.phone && !worker.phones?.some(phone => phone.includes(searchFilters.phone))) {
    return false;
  }

  if (searchFilters.profession && worker.profession !== searchFilters.profession) {
    return false;
  }

  if (searchFilters.status && worker.employmentStatus !== searchFilters.status) {
    return false;
  }

  if (searchFilters.delegate && worker.delegate !== searchFilters.delegate) {
    return false;
  }

  // فلتر العمر
  if (searchFilters.minAge || searchFilters.maxAge) {
    const currentYear = new Date().getFullYear();
    const age = worker.birthYear ? currentYear - parseInt(worker.birthYear) : null;
    
    if (age) {
      if (searchFilters.minAge && age < parseInt(searchFilters.minAge)) {
        return false;
      }
      if (searchFilters.maxAge && age > parseInt(searchFilters.maxAge)) {
        return false;
      }
    }
  }

  return true;
});
  // تبويبات النظام
  const tabs = [
    { id: 'search', name: 'البحث والعرض', icon: <Search className="w-5 h-5" /> },
    { id: 'add', name: 'إضافة عامل', icon: <UserPlus className="w-5 h-5" /> },
    { id: 'reports', name: 'التقارير', icon: <BarChart3 className="w-5 h-5" /> },
    { id: 'requests', name: 'الطلبات', icon: <FileText className="w-5 h-5" /> },
    { id: 'contacts', name: 'سجل الاتصالات', icon: <Phone className="w-5 h-5" /> },
    { id: 'reminders', name: 'التذكيرات', icon: <Bell className="w-5 h-5" /> },
    { id: 'import-export', name: 'التصدير والاستيراد', icon: <FileSpreadsheet className="w-5 h-5" /> }
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
          <div className="p-6 border-b border-gray-200">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3 space-x-reverse">
                <div className="p-2 bg-blue-100 rounded-lg">
                  <Users className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <h1 className="text-2xl font-bold text-gray-900">إدارة الموارد البشرية</h1>
                  <p className="text-gray-600">إدارة قاعدة بيانات العمالة والبحث عن المهن المطلوبة</p>
                </div>
              </div>
              <div className="flex items-center space-x-2 space-x-reverse">
                <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm font-medium">
                  {workers.length} عامل مسجل
                </span>
                <button
                  onClick={() => {
                    setActiveTab('add');
                    setShowAddForm(true);
                  }}
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center space-x-2 space-x-reverse"
                >
                  <Plus className="w-5 h-5" />
                  <span>إضافة عامل جديد</span>
                </button>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className="flex space-x-1 space-x-reverse overflow-x-auto">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center space-x-2 space-x-reverse px-4 py-3 text-sm font-medium rounded-t-lg transition-colors ${
                  activeTab === tab.id
                    ? 'bg-blue-50 text-blue-700 border-b-2 border-blue-600'
                    : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
                }`}
              >
                {tab.icon}
                <span>{tab.name}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
          {/* قسم البحث والعرض */}

{activeTab === 'search' && (
  <div className="p-6">
    <div className="mb-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">البحث والفلترة الذكية العالمية</h2>
      
      {/* البحث العالمي */}
      <div className="mb-6 bg-gradient-to-r from-blue-50 to-indigo-50 p-4 rounded-lg border border-blue-200">
        <label className="block text-sm font-medium text-blue-700 mb-2">
          🔍 البحث العالمي - ابحث في جميع البيانات
        </label>
        <input
          type="text"
          value={searchFilters.globalSearch || ''}
          onChange={(e) => setSearchFilters(prev => ({ ...prev, globalSearch: e.target.value }))}
          className="w-full p-3 border-2 border-blue-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-lg"
          placeholder="ابحث في أي حقل... مثال: سائق، مهندس، خبرة في الطبخ، أحمد، 01012345678"
        />
        <p className="text-xs text-blue-600 mt-1">
          البحث يشمل: الاسم، المهنة، الخبرات، المهارات، الملاحظات، التليفون، المؤهل، المندوب
        </p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">البحث بالاسم</label>
          <input
            type="text"
            value={searchFilters.name}
            onChange={(e) => setSearchFilters(prev => ({ ...prev, name: e.target.value }))}
            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="ادخل اسم العامل..."
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">البحث بالتليفون</label>
          <input
            type="text"
            value={searchFilters.phone}
            onChange={(e) => setSearchFilters(prev => ({ ...prev, phone: e.target.value }))}
            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="ادخل رقم التليفون..."
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">المهنة</label>
          <select
            value={searchFilters.profession}
            onChange={(e) => setSearchFilters(prev => ({ ...prev, profession: e.target.value }))}
            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">جميع المهن</option>
            {availableProfessions.map(prof => (
              <option key={prof.id} value={prof.name}>{prof.name}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">حالة التوظيف</label>
          <select
            value={searchFilters.status}
            onChange={(e) => setSearchFilters(prev => ({ ...prev, status: e.target.value }))}
            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">جميع الحالات</option>
            <option value="متاح">متاح</option>
            <option value="مشغول">مشغول</option>
            <option value="غير متاح">غير متاح</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">المندوب</label>
          <select
            value={searchFilters.delegate}
            onChange={(e) => setSearchFilters(prev => ({ ...prev, delegate: e.target.value }))}
            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">جميع المناديب</option>
            {delegates.map(delegate => (
              <option key={delegate.id} value={delegate.name}>{delegate.name}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">العمر من</label>
          <input
            type="number"
            value={searchFilters.minAge}
            onChange={(e) => setSearchFilters(prev => ({ ...prev, minAge: e.target.value }))}
            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            min="18"
            max="70"
            placeholder="مثال: 25"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">العمر إلى</label>
          <input
            type="number"
            value={searchFilters.maxAge}
            onChange={(e) => setSearchFilters(prev => ({ ...prev, maxAge: e.target.value }))}
            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            min="18"
            max="70"
            placeholder="مثال: 45"
          />
        </div>

        <div className="flex items-end">
          <button
            onClick={() => setSearchFilters({
              name: '', phone: '', profession: '', minExperience: '', maxExperience: '',
              minAge: '', maxAge: '', status: '', delegate: '', qualification: '', languages: '', 
              availability: '', globalSearch: ''
            })}
            className="w-full bg-gray-100 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-200 transition-colors"
          >
            إعادة تعيين
          </button>
        </div>
      </div>
    </div>

    {/* جدول النتائج المحسن */}
    <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
      <div className="p-4 bg-gray-50 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <h3 className="font-semibold text-gray-900">
            النتائج: {filteredWorkers.length} عامل
          </h3>
          <div className="text-sm text-gray-600">
            إجمالي المسجلين: {workers.length}
          </div>
        </div>
      </div>
      
      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gray-50">
              <th className="border border-gray-200 px-4 py-3 text-right font-medium text-gray-900">الاسم</th>
              <th className="border border-gray-200 px-4 py-3 text-right font-medium text-gray-900">المهنة</th>
              <th className="border border-gray-200 px-4 py-3 text-right font-medium text-gray-900">العمر</th>
              <th className="border border-gray-200 px-4 py-3 text-right font-medium text-gray-900">التليفون</th>
              <th className="border border-gray-200 px-4 py-3 text-right font-medium text-gray-900">الخبرات السابقة</th>
              <th className="border border-gray-200 px-4 py-3 text-right font-medium text-gray-900">الحالة</th>
              <th className="border border-gray-200 px-4 py-3 text-right font-medium text-gray-900">المندوب</th>
              <th className="border border-gray-200 px-4 py-3 text-right font-medium text-gray-900">السيرة الذاتية</th>
              <th className="border border-gray-200 px-4 py-3 text-right font-medium text-gray-900">الإجراءات</th>
            </tr>
          </thead>
          <tbody>
            {filteredWorkers.length > 0 ? (
              filteredWorkers.map((worker, index) => {
                // حساب العمر
                const currentYear = new Date().getFullYear();
                const age = worker.birthYear ? currentYear - parseInt(worker.birthYear) : null;
                
                return (
                  <tr key={worker.id || index} className="hover:bg-gray-50">
                    <td className="border border-gray-200 px-4 py-3">
                      <div className="font-medium text-gray-900">{worker.name}</div>
                      {worker.birthYear && (
                        <div className="text-xs text-gray-500">مواليد {worker.birthYear}</div>
                      )}
                    </td>
                    <td className="border border-gray-200 px-4 py-3">
                      <div className="font-medium">{worker.profession}</div>
                      {worker.professionDescription && (
                        <div className="text-xs text-gray-500 mt-1">{worker.professionDescription}</div>
                      )}
                    </td>
                    <td className="border border-gray-200 px-4 py-3">
                      {age ? (
                        <span className="font-medium text-blue-600">{age} سنة</span>
                      ) : (
                        <span className="text-gray-400">غير محدد</span>
                      )}
                    </td>
                    <td className="border border-gray-200 px-4 py-3">
                      <div className="space-y-1">
                        {worker.phones?.slice(0, 2).map((phone, idx) => (
                          <div key={idx} className="text-sm">
                            <a href={`tel:${phone}`} className="text-blue-600 hover:text-blue-800">
                              {phone}
                            </a>
                          </div>
                        ))}
                        {worker.phones?.length > 2 && (
                          <div className="text-xs text-gray-500">
                            +{worker.phones.length - 2} أخرى
                          </div>
                        )}
                      </div>
                    </td>
                    <td className="border border-gray-200 px-4 py-3">
                      <div className="max-w-xs">
                        {worker.previousExperience?.length > 0 ? (
                          <div className="space-y-1">
                            {worker.previousExperience.slice(0, 2).map((exp, idx) => (
                              <div key={idx} className="text-xs text-gray-600 truncate" title={exp}>
                                • {exp}
                              </div>
                            ))}
                            {worker.previousExperience.length > 2 && (
                              <div className="text-xs text-gray-500">
                                +{worker.previousExperience.length - 2} خبرة أخرى
                              </div>
                            )}
                          </div>
                        ) : (
                          <span className="text-gray-400 text-xs">لا توجد خبرات</span>
                        )}
                      </div>
                    </td>
                    <td className="border border-gray-200 px-4 py-3">
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                        worker.employmentStatus === 'متاح' ? 'bg-green-100 text-green-800' :
                        worker.employmentStatus === 'مشغول' ? 'bg-red-100 text-red-800' :
                        'bg-gray-100 text-gray-800'
                      }`}>
                        {worker.employmentStatus}
                      </span>
                    </td>
                    <td className="border border-gray-200 px-4 py-3">
                      {worker.delegate || '-'}
                    </td>
                    <td className="border border-gray-200 px-4 py-3">
                      {worker.cvFilePath ? (
                        <button
                          onClick={() => downloadCV(worker.id, worker.name)}
                          className="text-blue-600 hover:text-blue-800 flex items-center space-x-1 space-x-reverse"
                          title="تحميل السيرة الذاتية"
                        >
                          <Download className="w-4 h-4" />
                          <span className="text-xs">تحميل</span>
                        </button>
                      ) : (
                        <span className="text-gray-400 text-xs">غير متوفرة</span>
                      )}
                    </td>
                    <td className="border border-gray-200 px-4 py-3">
                      <div className="flex items-center space-x-2 space-x-reverse">
                        <button 
                          onClick={() => openEditModal(worker)}
                          className="text-blue-600 hover:text-blue-800 p-1 rounded"
                          title="تعديل"
                        >
                          <Edit className="w-4 h-4" />
                        </button>
                        <button 
                          onClick={() => openViewModal(worker)}
                          className="text-green-600 hover:text-green-800 p-1 rounded"
                          title="عرض التفاصيل"
                        >
                          <Eye className="w-4 h-4" />
                        </button>
                        <button 
                          onClick={() => deleteWorker(worker.id, worker.name)}
                          className="text-red-600 hover:text-red-800 p-1 rounded"
                          title="حذف"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="9" className="border border-gray-200 px-4 py-8 text-center text-gray-500">
                  <div className="flex flex-col items-center space-y-2">
                    <Search className="w-12 h-12 text-gray-300" />
                    <div className="text-lg font-medium">لا توجد نتائج</div>
                    <div className="text-sm">جرب تغيير معايير البحث أو المرشحات</div>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  </div>
)}

        



{activeTab === 'add' && (
  <div className="p-6">
    <h2 className="text-lg font-semibold text-gray-900 mb-6">إضافة عامل جديد</h2>
    
    {/* قسم السيرة الذاتية - مصغر ومحسن */}
    <div className="bg-gradient-to-r from-purple-50 to-indigo-50 border border-purple-200 rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-semibold text-purple-900 flex items-center">
          <Brain className="w-5 h-5 ml-2" />
          إدارة السيرة الذاتية  
        </h3>
        {newWorker.cvFile && (
          <div className="flex items-center space-x-2 space-x-reverse text-sm">
            <FileCheck className="w-4 h-4 text-green-600" />
            <span className="text-green-600 font-medium">{newWorker.cvFile.name}</span>
          </div>
        )}
      </div>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {/* رفع السيرة الذاتية */}
        <label className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center justify-center space-x-2 space-x-reverse text-sm cursor-pointer transition-colors">
          <Upload className="w-4 h-4" />
          <span>رفع CV</span>
          <input 
            type="file" 
            className="hidden" 
            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            onChange={(e) => {
              const file = e.target.files[0];
              if (file) {
                setNewWorker(prev => ({ ...prev, cvFile: file }));
              }
            }}
          />
        </label>
        
        {/* تحليل السيرة الذاتية */}
        <button
          onClick={() => newWorker.cvFile && analyzeCVFile(newWorker.cvFile)}
          disabled={!newWorker.cvFile || analyzingCV}
          className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 disabled:bg-gray-400 flex items-center justify-center space-x-2 space-x-reverse text-sm transition-colors"
        >
          {analyzingCV ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
              <span>{analysisProgress}%</span>
            </>
          ) : (
            <>
              <Scan className="w-4 h-4" />
              <span>تحليل</span>
            </>
          )}
        </button>

        {/* معاينة السيرة الذاتية */}
        <button
          onClick={() => newWorker.cvFile && previewCV(newWorker.cvFile)}
          disabled={!newWorker.cvFile}
          className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 disabled:bg-gray-400 flex items-center justify-center space-x-2 space-x-reverse text-sm transition-colors"
        >
          <Eye className="w-4 h-4" />
          <span>معاينة</span>
        </button>

        {/* تحميل السيرة الذاتية */}
        <button
          onClick={() => newWorker.cvFile && downloadFile(newWorker.cvFile, 'CV')}
          disabled={!newWorker.cvFile}
          className="bg-teal-600 text-white px-4 py-2 rounded-lg hover:bg-teal-700 disabled:bg-gray-400 flex items-center justify-center space-x-2 space-x-reverse text-sm transition-colors"
        >
          <Download className="w-4 h-4" />
          <span>تحميل</span>
        </button>
      </div>

      {/* شريط التقدم للتحليل */}
      {analyzingCV && (
        <div className="mt-3">
          <div className="flex justify-between text-xs text-purple-700 mb-1">
            <span>{analysisStep}</span>
            <span>{analysisProgress}%</span>
          </div>
          <div className="w-full bg-purple-100 rounded-full h-2">
            <div 
              className="bg-purple-600 h-2 rounded-full transition-all duration-300"
              style={{ width: `${analysisProgress}%` }}
            ></div>
          </div>
        </div>
      )}





      {cvAnalysis && (
  <div className="mt-3 bg-white border border-purple-200 rounded-lg p-3">
    <div className="flex items-center justify-between">
      <h4 className="text-sm font-medium text-purple-900">نتائج التحليل السريع</h4>
      <button
        onClick={() => setShowMiniAnalysis(!showMiniAnalysis)}
        className="text-purple-600 hover:text-purple-800 text-xs"
      >
        {showMiniAnalysis ? 'إخفاء' : 'عرض التفاصيل'}
      </button>
    </div>
    
    {/* معاينة سريعة */}
    <div className="grid grid-cols-2 gap-2 mt-2 text-xs">
      <div>
        <span className="font-medium text-gray-600">الاسم:</span>
        <span className="text-purple-800 mr-1">{cvAnalysis.personalInfo?.name || 'غير محدد'}</span>
      </div>
      <div>
        <span className="font-medium text-gray-600">المهنة:</span>
        <span className="text-purple-800 mr-1">{cvAnalysis.profession?.current || 'غير محدد'}</span>
      </div>
      <div>
        <span className="font-medium text-gray-600">التليفون:</span>
        <span className="text-purple-800 mr-1">{cvAnalysis.personalInfo?.phone || 'غير محدد'}</span>
      </div>
      <div>
        <span className="font-medium text-gray-600">الإيميل:</span>
        <span className="text-purple-800 mr-1">{cvAnalysis.personalInfo?.email || 'غير محدد'}</span>
      </div>
    </div>
    
    {/* التفاصيل الكاملة */}
    {showMiniAnalysis && (
      <div className="mt-3 pt-3 border-t border-purple-100">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-xs">
          {cvAnalysis.personalInfo?.birthDate && (
            <div>
              <span className="font-medium text-gray-600">تاريخ الميلاد:</span>
              <span className="text-purple-800 mr-1">{cvAnalysis.personalInfo.birthDate}</span>
            </div>
          )}
          {cvAnalysis.personalInfo?.maritalStatus && (
            <div>
              <span className="font-medium text-gray-600">الحالة الاجتماعية:</span>
              <span className="text-purple-800 mr-1">{cvAnalysis.personalInfo.maritalStatus}</span>
            </div>
          )}
          {cvAnalysis.qualifications?.education && (
            <div>
              <span className="font-medium text-gray-600">المؤهل:</span>
              <span className="text-purple-800 mr-1">{cvAnalysis.qualifications.education}</span>
            </div>
          )}
          {cvAnalysis.profession?.experienceYears > 0 && (
            <div>
              <span className="font-medium text-gray-600">سنوات الخبرة:</span>
              <span className="text-purple-800 mr-1">{cvAnalysis.profession.experienceYears}</span>
            </div>
          )}
        </div>
        
        {cvAnalysis.skills && cvAnalysis.skills.length > 0 && (
          <div className="mt-2">
            <span className="font-medium text-gray-600 text-xs">المهارات:</span>
            <div className="flex flex-wrap gap-1 mt-1">
              {cvAnalysis.skills.slice(0, 6).map((skill, index) => (
                <span key={index} className="px-2 py-1 bg-purple-100 text-purple-700 text-xs rounded-full">
                  {skill}
                </span>
              ))}
              {cvAnalysis.skills.length > 6 && (
                <span className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded-full">
                  +{cvAnalysis.skills.length - 6} أخرى
                </span>
              )}
            </div>
          </div>
        )}
        
        <div className="flex justify-between items-center mt-3">
          <button
            onClick={fillDataFromCV}
            className="bg-purple-600 text-white px-4 py-1 rounded text-xs hover:bg-purple-700"
          >
            ملء البيانات تلقائياً
          </button>
          <button
            onClick={() => setShowCVAnalysis(true)}
            className="text-purple-600 hover:text-purple-800 text-xs underline"
          >
            عرض التفاصيل الكاملة
          </button>
        </div>
      </div>
    )}
  </div>
)}


    </div>
    
    <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
      
      {/* البيانات الشخصية - عمود منفصل */}
      <div className="space-y-6">
        <div className="bg-blue-50 p-4 rounded-lg border-2 border-blue-200">
          <h3 className="font-bold text-blue-900 mb-4 flex items-center text-lg">
            <User className="w-6 h-6 ml-2" />
            البيانات الشخصية
          </h3>
          
          {/* الاسم */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-blue-700 mb-2">الاسم الكامل *</label>
            <input
              type="text"
              value={newWorker.name}
              onChange={(e) => setNewWorker(prev => ({ ...prev, name: e.target.value }))}
              className="w-full p-3 border-2 border-blue-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
              placeholder="ادخل الاسم الكامل..."
              required
            />
          </div>

          {/* سنة الميلاد */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-blue-700 mb-2">سنة الميلاد</label>
            <input
              type="number"
              value={newWorker.birthYear}
              onChange={(e) => setNewWorker(prev => ({ ...prev, birthYear: e.target.value }))}
              className="w-full p-3 border-2 border-blue-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
              min="1950"
              max={new Date().getFullYear()}
              placeholder="مثال: 1990"
            />
            {newWorker.birthYear && (
              <p className="text-xs text-blue-600 mt-1">
                العمر الحالي: {new Date().getFullYear() - parseInt(newWorker.birthYear)} سنة
              </p>
            )}
          </div>

          {/* أرقام التليفون */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-blue-700 mb-2">أرقام التليفون</label>
            <div className="space-y-2">
              {newWorker.phones.map((phone, index) => (
                <div key={index} className="flex space-x-2 space-x-reverse">
                  <input
                    type="tel"
                    value={phone}
                    onChange={(e) => updatePhone(index, e.target.value)}
                    className="flex-1 p-2 border border-blue-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                    placeholder={`التليفون ${index + 1}...`}
                  />
                  {newWorker.phones.length > 1 && (
                    <button
                      onClick={() => removePhone(index)}
                      className="bg-red-100 text-red-600 px-2 py-2 rounded-lg hover:bg-red-200"
                      title="حذف الرقم"
                    >
                      <X className="w-4 h-4" />
                    </button>
                  )}
                </div>
              ))}
              <button
                onClick={addPhoneNumber}
                className="w-full bg-blue-100 text-blue-700 px-3 py-2 rounded-lg hover:bg-blue-200 transition-colors flex items-center justify-center space-x-1 space-x-reverse text-sm"
              >
                <Plus className="w-4 h-4" />
                <span>إضافة رقم آخر</span>
              </button>
            </div>
          </div>

          {/* المندوب */}
          <div>
            <label className="block text-sm font-medium text-blue-700 mb-2">المندوب </label>
            <select
              value={newWorker.delegate}
              onChange={(e) => setNewWorker(prev => ({ ...prev, delegate: e.target.value }))}
              className="w-full p-3 border-2 border-blue-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
            >
              <option value="">اختر المندوب...</option>
              {delegates.map(delegate => (
                <option key={delegate.id} value={delegate.name}>{delegate.name}</option>
              ))}
            </select>
          </div>


              {/* الملاحظات */}
<div className="mt-4">
  <label className="block text-sm font-medium text-blue-700 mb-2">ملاحظات مهمة</label>
  <textarea
    value={newWorker.notes}
    onChange={(e) => setNewWorker(prev => ({ ...prev, notes: e.target.value }))}
    className="w-full p-3 border-2 border-blue-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
    rows="3"
    placeholder="أي ملاحظات مهمة عن هذا الشخص..."
  />
</div>


        </div>
      </div>

      {/* البيانات الأساسية */}
      <div className="space-y-6">
        <div className="bg-green-50 p-4 rounded-lg border-2 border-green-200">
          <h3 className="font-bold text-green-900 mb-4 flex items-center text-lg">
            <Briefcase className="w-6 h-6 ml-2" />
            البيانات الأساسية
          </h3>

          {/* المهنة */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-green-700 mb-2">المهنة *</label>
            <div className="flex space-x-2 space-x-reverse">
              <select
                value={newWorker.profession}
                onChange={(e) => setNewWorker(prev => ({ ...prev, profession: e.target.value }))}
                className="flex-1 p-3 border-2 border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 bg-white"
                required
              >
                <option value="">اختر المهنة...</option>
                {availableProfessions.map(prof => (
                  <option key={prof.id} value={prof.name}>{prof.name}</option>
                ))}
              </select>
              <button
                onClick={() => setShowAddProfession(true)}
                className="bg-green-600 text-white px-3 py-3 rounded-lg hover:bg-green-700"
                title="إضافة مهنة جديدة"
              >
                <Plus className="w-5 h-5" />
              </button>
            </div>
          </div>

          {/* وصف المهنة */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-green-700 mb-2">وصف المهنة</label>
            <textarea
              value={newWorker.professionDescription}
              onChange={(e) => setNewWorker(prev => ({ ...prev, professionDescription: e.target.value }))}
              className="w-full p-3 border-2 border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 bg-white"
              rows="3"
              placeholder="وصف تفصيلي للمهنة والمهام..."
            />
          </div>

          {/* المؤهل الدراسي */}
          <div className="mb-4">
            <div className="flex items-center justify-between mb-2">
              <label className="block text-sm font-medium text-green-700">المؤهل الدراسي</label>
              <button
                onClick={() => setShowQualificationManager(true)}
                className="text-green-600 hover:text-green-800 text-xs flex items-center"
                type="button"
              >
                <Settings className="w-3 h-3 ml-1" />
                إدارة المؤهلات
              </button>
            </div>
            
            <div className="space-y-2">
              <select
                value={newWorker.qualification.level}
                onChange={(e) => {
                  const selectedLevel = e.target.value;
                  setNewWorker(prev => ({ 
                    ...prev, 
                    qualification: { 
                      level: selectedLevel, 
                      specialization: '', 
                      details: '' 
                    } 
                  }));
                }}
                className="w-full p-3 border-2 border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 bg-white"
              >
                <option value="">اختر المؤهل...</option>
                {qualificationLevels.map(level => (
                  <option key={level.id} value={level.name}>{level.name}</option>
                ))}
              </select>

              {newWorker.qualification.level && 
               qualificationLevels.find(level => level.name === newWorker.qualification.level)?.hasSpecialization && (
                <select
                  value={newWorker.qualification.specialization}
                  onChange={(e) => setNewWorker(prev => ({ 
                    ...prev, 
                    qualification: { 
                      ...prev.qualification, 
                      specialization: e.target.value 
                    } 
                  }))}
                  className="w-full p-2 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 bg-white"
                >
                  <option value="">اختر التخصص...</option>
                  {(qualificationSpecializations[newWorker.qualification.level] || []).map((spec, index) => (
                    <option key={index} value={spec}>{spec}</option>
                  ))}
                </select>
              )}
            </div>
          </div>

          {/* سنوات الخبرة */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-green-700 mb-2">سنوات الخبرة</label>
            <input
              type="number"
              value={newWorker.experienceYears}
              onChange={(e) => setNewWorker(prev => ({ ...prev, experienceYears: parseInt(e.target.value) || 0 }))}
              className="w-full p-3 border-2 border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 bg-white"
              min="0"
              max="50"
            />
          </div>

          {/* الخبرات السابقة */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-green-700 mb-2">الخبرات السابقة</label>
            <div className="space-y-2">
              {newWorker.previousExperience.map((experience, index) => (
                <div key={index} className="flex space-x-2 space-x-reverse">
                  <input
                    type="text"
                    value={experience}
                    onChange={(e) => updateExperience(index, e.target.value)}
                    className="flex-1 p-2 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 bg-white"
                    placeholder={`الخبرة ${index + 1}...`}
                  />
                  {newWorker.previousExperience.length > 1 && (
                    <button
                      onClick={() => removeExperience(index)}
                      className="bg-red-100 text-red-600 px-2 py-2 rounded-lg hover:bg-red-200"
                      title="حذف الخبرة"
                    >
                      <X className="w-4 h-4" />
                    </button>
                  )}
                </div>
              ))}
              <button
                onClick={addExperience}
                className="w-full bg-green-100 text-green-700 px-3 py-2 rounded-lg hover:bg-green-200 transition-colors flex items-center justify-center space-x-1 space-x-reverse text-sm"
              >
                <Plus className="w-4 h-4" />
                <span>إضافة خبرة أخرى</span>
              </button>
            </div>
          </div>

 {/* المهارات */}
<div>
  <label className="block text-sm font-medium text-green-700 mb-2">المهارات</label>
  <div className="space-y-2">
    {newWorker.skills?.map((skill, index) => (
      <div key={index} className="flex space-x-2 space-x-reverse">
        <input
          type="text"
          value={skill}
          onChange={(e) => {
            const newSkills = [...(newWorker.skills || [])];
            newSkills[index] = e.target.value;
            setNewWorker(prev => ({ ...prev, skills: newSkills }));
          }}
          className="flex-1 p-2 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 bg-white"
          placeholder={`المهارة ${index + 1}...`}
        />
        {(newWorker.skills?.length || 0) > 1 && (
          <button
            onClick={() => {
              const newSkills = (newWorker.skills || []).filter((_, i) => i !== index);
              setNewWorker(prev => ({ ...prev, skills: newSkills }));
            }}
            className="bg-red-100 text-red-600 px-2 py-2 rounded-lg hover:bg-red-200"
            title="حذف المهارة"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    ))}
    <button
      onClick={() => {
        const currentSkills = newWorker.skills || [''];
        setNewWorker(prev => ({ ...prev, skills: [...currentSkills, ''] }));
      }}
      className="w-full bg-green-100 text-green-700 px-3 py-2 rounded-lg hover:bg-green-200 transition-colors flex items-center justify-center space-x-1 space-x-reverse text-sm"
    >
      <Plus className="w-4 h-4" />
      <span>إضافة مهارة أخرى</span>
    </button>
  </div>
</div>
        </div>
      </div>

      {/* البيانات الإضافية */}
      <div className="space-y-6">
        <div className="bg-orange-50 p-4 rounded-lg border-2 border-orange-200">
          <h3 className="font-bold text-orange-900 mb-4 flex items-center text-lg">
            <Settings className="w-6 h-6 ml-2" />
            البيانات الإضافية
          </h3>

          {/* بيانات الجواز والرخصة */}
          <div className="mb-4">
            <h4 className="font-medium text-orange-800 mb-2">بيانات الجواز والرخصة</h4>
            <div className="space-y-2">
              <input
                type="text"
                value={newWorker.passportProfession}
                onChange={(e) => setNewWorker(prev => ({ ...prev, passportProfession: e.target.value }))}
                className="w-full p-2 border border-orange-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white"
                placeholder="مهنة الجواز..."
              />
              <input
                type="text"
                value={newWorker.license}
                onChange={(e) => setNewWorker(prev => ({ ...prev, license: e.target.value }))}
                className="w-full p-2 border border-orange-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white"
                placeholder="رقم الرخصة..."
              />
            </div>
          </div>

          {/* العنوان */}
          <div className="mb-4">
            <h4 className="font-medium text-orange-800 mb-2">العنوان</h4>
            <div className="grid grid-cols-2 gap-2">
              <input
                type="text"
                value={newWorker.address.governorate}
                onChange={(e) => setNewWorker(prev => ({
                  ...prev,
                  address: { ...prev.address, governorate: e.target.value }
                }))}
                className="w-full p-2 border border-orange-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white"
                placeholder="المحافظة..."
              />
              <input
                type="text"
                value={newWorker.address.city}
                onChange={(e) => setNewWorker(prev => ({
                  ...prev,
                  address: { ...prev.address, city: e.target.value }
                }))}
                className="w-full p-2 border border-orange-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white"
                placeholder="المدينة..."
              />
            </div>
          </div>

          {/* الحالة الاجتماعية */}
          <div className="mb-4">
            <h4 className="font-medium text-orange-800 mb-2">الحالة الاجتماعية</h4>
            <select
              value={newWorker.maritalStatus}
              onChange={(e) => setNewWorker(prev => ({ ...prev, maritalStatus: e.target.value }))}
              className="w-full p-2 border border-orange-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white"
            >
              <option value="أعزب">أعزب</option>
              <option value="متزوج">متزوج</option>
              <option value="مطلق">مطلق</option>
              <option value="أرمل">أرمل</option>
            </select>
          </div>

          {/* اللغات */}
          <div className="mb-4">
            <h4 className="font-medium text-orange-800 mb-2">اللغات</h4>
            <div className="grid grid-cols-2 gap-1">
              {['عربي', 'إنجليزي', 'فرنسي', 'ألماني', 'إيطالي', 'أسباني'].map((lang) => (
                <label key={lang} className="flex items-center text-sm">
                  <input
                    type="checkbox"
                    checked={newWorker.languages.includes(lang)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setNewWorker(prev => ({
                          ...prev,
                          languages: [...prev.languages, lang]
                        }));
                      } else {
                        setNewWorker(prev => ({
                          ...prev,
                          languages: prev.languages.filter(l => l !== lang)
                        }));
                      }
                    }}
                    className="ml-1 h-3 w-3 text-orange-600 focus:ring-orange-500 border-orange-300 rounded"
                  />
                  <span className="text-orange-700">{lang}</span>
                </label>
              ))}
            </div>
          </div>

          {/* الراتب */}
          <div className="mb-4">
            <h4 className="font-medium text-orange-800 mb-2">الراتب</h4>
            <div className="grid grid-cols-2 gap-2">
              <input
                type="text"
                value={newWorker.lastSalary}
                onChange={(e) => setNewWorker(prev => ({ ...prev, lastSalary: e.target.value }))}
                className="w-full p-2 border border-orange-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white"
                placeholder="آخر راتب..."
              />
              <input
                type="text"
                value={newWorker.requestedSalary}
                onChange={(e) => setNewWorker(prev => ({ ...prev, requestedSalary: e.target.value }))}
                className="w-full p-2 border border-orange-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white"
                placeholder="الراتب المطلوب..."
              />
            </div>
          </div>

          {/* حالة التوظيف */}
          <div className="mb-4">
            <h4 className="font-medium text-orange-800 mb-2">حالة التوظيف</h4>
            <select
              value={newWorker.employmentStatus}
              onChange={(e) => setNewWorker(prev => ({ ...prev, employmentStatus: e.target.value }))}
              className="w-full p-2 border border-orange-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white"
            >
              <option value="متاح">متاح</option>
              <option value="مشغول">مشغول</option>
              <option value="غير متاح">غير متاح</option>
            </select>
          </div>

          {/* الصورة الشخصية */}
          <div>
            <h4 className="font-medium text-orange-800 mb-2">الصورة الشخصية</h4>
            <div className="border-2 border-dashed border-orange-300 rounded-lg p-3 text-center">
              {newWorker.photo ? (
                <div className="space-y-2">
                  <img 
                    src={URL.createObjectURL(newWorker.photo)} 
                    alt="صورة العامل"
                    className="w-20 h-20 object-cover rounded-lg mx-auto"
                  />
                  <p className="text-xs text-green-600">{newWorker.photo.name}</p>
                  <div className="flex justify-center space-x-2 space-x-reverse">
                    <button
                      onClick={() => previewImage(newWorker.photo)}
                      className="text-blue-600 hover:text-blue-800 text-xs flex items-center"
                    >
                      <Eye className="w-3 h-3 ml-1" />
                      معاينة
                    </button>
                    <button
                      onClick={() => downloadFile(newWorker.photo, 'صورة')}
                      className="text-green-600 hover:text-green-800 text-xs flex items-center"
                    >
                      <Download className="w-3 h-3 ml-1" />
                      تحميل
                    </button>
                    <button
                      onClick={() => setNewWorker(prev => ({ ...prev, photo: null }))}
                      className="text-red-600 hover:text-red-800 text-xs flex items-center"
                    >
                      <X className="w-3 h-3 ml-1" />
                      حذف
                    </button>
                  </div>
                </div>
              ) : (
                <label className="cursor-pointer">
                  <Camera className="w-8 h-8 mx-auto text-orange-400 mb-2" />
                  <p className="text-sm text-orange-600">اضغط لرفع صورة</p>
                  <input 
                    type="file" 
                    className="hidden" 
                    accept="image/*"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        setNewWorker(prev => ({ ...prev, photo: file }));
                      }
                    }}
                  />
                </label>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* أزرار الحفظ */}
    <div className="flex space-x-3 space-x-reverse pt-6 mt-6 border-t-2 border-gray-200">
      <button
        onClick={saveWorker}
        disabled={loading || !newWorker.name || !newWorker.profession}
        className="flex-1 bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center justify-center space-x-2 space-x-reverse font-medium"
      >
        {loading ? (
          <>
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
            <span>جاري الحفظ...</span>
          </>
        ) : (
          <>
            <Save className="w-5 h-5" />
            <span>حفظ بيانات العامل</span>
          </>
        )}
      </button>
      <button
        onClick={resetForm}
        className="px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-medium"
      >
        إعادة تعيين
      </button>
    </div>
  </div>
)}



        {/* قسم التقارير */}
        {activeTab === 'reports' && (
          <div className="p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-6">التقارير والإحصائيات</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <div className="bg-blue-50 p-6 rounded-lg border border-blue-200">
  <div className="flex items-center justify-between">
    <div>
      <p className="text-blue-600 text-sm font-medium">إجمالي العمال</p>
      <p className="text-2xl font-bold text-blue-900">{workers.length}</p>
    </div>
    <Users className="w-8 h-8 text-blue-600" />
  </div>
</div>


              <div className="bg-green-50 p-6 rounded-lg border border-green-200">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-green-600 text-sm font-medium">العمال المتاحين</p>
                    <p className="text-2xl font-bold text-green-900">
                      {workers.filter(w => w.employmentStatus === 'متاح').length}
                    </p>
                  </div>
                  <CheckCircle className="w-8 h-8 text-green-600" />
                </div>
              </div>

              <div className="bg-red-50 p-6 rounded-lg border border-red-200">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-red-600 text-sm font-medium">العمال المشغولين</p>
                    <p className="text-2xl font-bold text-red-900">
                      {workers.filter(w => w.employmentStatus === 'مشغول').length}
                    </p>
                  </div>
                  <Clock className="w-8 h-8 text-red-600" />
                </div>
              </div>

              <div className="bg-purple-50 p-6 rounded-lg border border-purple-200">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-purple-600 text-sm font-medium">مسجلين هذا الشهر</p>
                    <p className="text-2xl font-bold text-purple-900">
                      {workers.filter(w => {
                        const regDate = new Date(w.registrationDate);
                        const now = new Date();
                        return regDate.getMonth() === now.getMonth() && 
                               regDate.getFullYear() === now.getFullYear();
                      }).length}
                    </p>
                  </div>
                  <Calendar className="w-8 h-8 text-purple-600" />
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <h3 className="font-semibold text-gray-900 mb-4">توزيع العمال حسب المهنة</h3>
                <div className="space-y-3">
                  {availableProfessions.slice(0, 5).map(profession => {
                    const count = workers.filter(w => w.profession === profession.name).length;
                    const percentage = workers.length > 0 ? (count / workers.length * 100).toFixed(1) : 0;
                    
                    return (
                      <div key={profession.id} className="flex items-center justify-between">
                        <span className="text-sm text-gray-700">{profession.name}</span>
                        <div className="flex items-center space-x-2 space-x-reverse">
                          <span className="text-sm font-medium text-gray-900">{count}</span>
                          <div className="w-24 bg-gray-200 rounded-full h-2">
                            <div 
                              className="bg-blue-600 h-2 rounded-full" 
                              style={{ width: `${percentage}%` }}
                            ></div>
                          </div>
                          <span className="text-xs text-gray-500">{percentage}%</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <h3 className="font-semibold text-gray-900 mb-4">توزيع العمال حسب المناديب</h3>
                <div className="space-y-3">
                  {delegates.slice(0, 5).map(delegate => {
                    const count = workers.filter(w => w.delegate === delegate.name).length;
                    const percentage = workers.length > 0 ? (count / workers.length * 100).toFixed(1) : 0;
                    
                    return (
                      <div key={delegate.id} className="flex items-center justify-between">
                        <span className="text-sm text-gray-700">{delegate.name}</span>
                        <div className="flex items-center space-x-2 space-x-reverse">
                          <span className="text-sm font-medium text-gray-900">{count}</span>
                          <div className="w-24 bg-gray-200 rounded-full h-2">
                            <div 
                              className="bg-green-600 h-2 rounded-full" 
                              style={{ width: `${percentage}%` }}
                            ></div>
                          </div>
                          <span className="text-xs text-gray-500">{percentage}%</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* قسم الطلبات */}
        {activeTab === 'requests' && (
          <div className="p-6">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-lg font-semibold text-gray-900">إدارة الطلبات</h2>
              <button className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center space-x-2 space-x-reverse">
                <Plus className="w-5 h-5" />
                <span>طلب عمالة جديد</span>
              </button>
            </div>
            
            <div className="bg-gray-50 rounded-lg p-8 text-center">
              <FileText className="w-16 h-16 text-gray-400 mx-auto mb-4" />
              <h3 className="text-lg font-medium text-gray-900 mb-2">قسم الطلبات</h3>
              <p className="text-gray-600 mb-4">
                يتيح لك هذا القسم إدارة طلبات العمالة وربط العمال المناسبين بالطلبات
              </p>
              <p className="text-sm text-gray-500">قريباً...</p>
            </div>
          </div>
        )}

        {/* قسم سجل الاتصالات */}
        {activeTab === 'contacts' && (
          <div className="p-6">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-lg font-semibold text-gray-900">سجل الاتصالات</h2>
              <button className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 flex items-center space-x-2 space-x-reverse">
                <Phone className="w-5 h-5" />
                <span>تسجيل مكالمة جديدة</span>
              </button>
            </div>
            
            <div className="bg-gray-50 rounded-lg p-8 text-center">
              <Phone className="w-16 h-16 text-gray-400 mx-auto mb-4" />
              <h3 className="text-lg font-medium text-gray-900 mb-2">سجل الاتصالات</h3>
              <p className="text-gray-600 mb-4">
                تتبع جميع المكالمات مع العمال ونتائج الاتصالات
              </p>
              <p className="text-sm text-gray-500">قريباً...</p>
            </div>
          </div>
        )}

        {/* قسم التذكيرات */}
        {activeTab === 'reminders' && (
          <div className="p-6">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-lg font-semibold text-gray-900">التذكيرات</h2>
              <button className="bg-yellow-600 text-white px-4 py-2 rounded-lg hover:bg-yellow-700 flex items-center space-x-2 space-x-reverse">
                <Bell className="w-5 h-5" />
                <span>إضافة تذكير جديد</span>
              </button>
            </div>
            
            <div className="bg-gray-50 rounded-lg p-8 text-center">
              <Bell className="w-16 h-16 text-gray-400 mx-auto mb-4" />
              <h3 className="text-lg font-medium text-gray-900 mb-2">التذكيرات</h3>
              <p className="text-gray-600 mb-4">
                إدارة التذكيرات للمتابعة والتحديث
              </p>
              <p className="text-sm text-gray-500">قريباً...</p>
            </div>
          </div>
        )}

        {/* قسم التصدير والاستيراد */}
        {activeTab === 'import-export' && (
          <div className="p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-6">التصدير والاستيراد</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
                <h3 className="font-semibold text-blue-900 mb-4 flex items-center">
                  <Upload className="w-5 h-5 ml-2" />
                  استيراد البيانات
                </h3>
                <p className="text-blue-700 text-sm mb-4">
                  استيراد بيانات العمال من ملف Excel
                </p>
                <div className="space-y-3">
                  <button className="w-full bg-blue-600 text-white px-4 py-3 rounded-lg hover:bg-blue-700 flex items-center justify-center space-x-2 space-x-reverse">
                    <Upload className="w-5 h-5" />
                    <span>اختيار ملف Excel</span>
                  </button>
                  <button className="w-full bg-blue-100 text-blue-700 px-4 py-2 rounded-lg hover:bg-blue-200 flex items-center justify-center space-x-2 space-x-reverse">
                    <Download className="w-5 h-5" />
                    <span>تحميل نموذج Excel</span>
                  </button>
                </div>
              </div>

              <div className="bg-green-50 border border-green-200 rounded-lg p-6">
                <h3 className="font-semibold text-green-900 mb-4 flex items-center">
                  <Download className="w-5 h-5 ml-2" />
                  تصدير البيانات
                </h3>
                <p className="text-green-700 text-sm mb-4">
                  تصدير بيانات العمال إلى ملف Excel
                </p>
                <div className="space-y-3">
                  <button className="w-full bg-green-600 text-white px-4 py-3 rounded-lg hover:bg-green-700 flex items-center justify-center space-x-2 space-x-reverse">
                    <Download className="w-5 h-5" />
                    <span>تصدير جميع العمال</span>
                  </button>
                  <button className="w-full bg-green-600 text-white px-4 py-3 rounded-lg hover:bg-green-700 flex items-center justify-center space-x-2 space-x-reverse">
                    <Download className="w-5 h-5" />
                    <span>تصدير نتائج البحث</span>
                  </button>
                  <button className="w-full bg-green-100 text-green-700 px-4 py-2 rounded-lg hover:bg-green-200 flex items-center justify-center space-x-2 space-x-reverse">
                    <Save className="w-5 h-5" />
                    <span>نسخة احتياطية من قاعدة البيانات</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* نافذة عرض تحليل السيرة الذاتية */}
      {showCVAnalysis && cvAnalysis && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-gray-200">
              <div className="flex items-center justify-between">
                <h3 className="text-xl font-bold text-gray-900 flex items-center">
                  <Brain className="w-6 h-6 ml-2 text-purple-600" />
                  تحليل السيرة الذاتية
                </h3>
                <button
                  onClick={() => setShowCVAnalysis(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>
              <div className="flex items-center space-x-2 space-x-reverse mt-2">
                <div className="flex items-center space-x-1 space-x-reverse">
                  <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                  <span className="text-sm text-gray-600">
                    دقة التحليل: {Math.round(cvAnalysis.confidence * 100)}%
                  </span>
                </div>
                {cvAnalysis.detectedLanguage !== 'ar' && (
                  <div className="flex items-center space-x-1 space-x-reverse">
                    <Globe className="w-4 h-4 text-blue-500" />
                    <span className="text-sm text-blue-600">تم ترجمة السيرة الذاتية</span>
                  </div>
                )}
              </div>
            </div>
            
            <div className="p-6">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* البيانات الشخصية */}
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <h4 className="font-semibold text-blue-900 mb-3 flex items-center">
                    <User className="w-5 h-5 ml-2" />
                    البيانات الشخصية
                  </h4>
                  <div className="space-y-2 text-sm">
                    <div><span className="font-medium">الاسم:</span> {cvAnalysis.personalInfo.name}</div>
                    <div><span className="font-medium">التليفون:</span> {cvAnalysis.personalInfo.phone}</div>
                    <div><span className="font-medium">الإيميل:</span> {cvAnalysis.personalInfo.email}</div>
                    <div><span className="font-medium">الجنسية:</span> {cvAnalysis.personalInfo.nationality}</div>
                    <div><span className="font-medium">تاريخ الميلاد:</span> {cvAnalysis.personalInfo.birthDate}</div>
                    <div><span className="font-medium">الحالة الاجتماعية:</span> {cvAnalysis.personalInfo.maritalStatus}</div>
                  </div>
                </div>

                {/* العنوان */}
                <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                  <h4 className="font-semibold text-green-900 mb-3 flex items-center">
                    <MapPin className="w-5 h-5 ml-2" />
                    العنوان
                  </h4>
                  <div className="space-y-2 text-sm">
                    <div><span className="font-medium">البلد:</span> {cvAnalysis.address.country}</div>
                    <div><span className="font-medium">المحافظة:</span> {cvAnalysis.address.governorate}</div>
                    <div><span className="font-medium">المدينة:</span> {cvAnalysis.address.city}</div>
                  </div>
                </div>

                {/* المهنة والخبرة */}
                <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
                  <h4 className="font-semibold text-purple-900 mb-3 flex items-center">
                    <Briefcase className="w-5 h-5 ml-2" />
                    المهنة والخبرة
                  </h4>
                  <div className="space-y-2 text-sm">
                    <div><span className="font-medium">المهنة الحالية:</span> {cvAnalysis.profession.current}</div>
                    <div><span className="font-medium">مهنة الجواز:</span> {cvAnalysis.profession.passportProfession}</div>
                    <div><span className="font-medium">سنوات الخبرة:</span> {cvAnalysis.profession.experienceYears} سنة</div>
                  </div>
                </div>

                {/* المؤهلات */}
                <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
                  <h4 className="font-semibold text-orange-900 mb-3 flex items-center">
                    <GraduationCap className="w-5 h-5 ml-2" />
                    المؤهلات
                  </h4>
                  <div className="space-y-2 text-sm">
                    <div><span className="font-medium">التعليم:</span> {cvAnalysis.qualifications.education}</div>
                    <div><span className="font-medium">الرخص:</span> {cvAnalysis.qualifications.licenses?.join(', ')}</div>
                    <div><span className="font-medium">اللغات:</span> {cvAnalysis.qualifications.languages?.join(', ')}</div>
                  </div>
                </div>


{/* الخبرات السابقة - الكود المحدث */}
<div className="bg-indigo-50 border border-indigo-200 rounded-lg p-4 lg:col-span-2">
  <h4 className="font-semibold text-indigo-900 mb-3 flex items-center">
    <Clock className="w-5 h-5 ml-2" />
    الخبرات السابقة
  </h4>
  <div className="space-y-2">
    {cvAnalysis.experience && cvAnalysis.experience.length > 0 ? (
      cvAnalysis.experience.map((exp, index) => (
        <div key={index} className="text-sm bg-white p-2 rounded border">
          {typeof exp === 'string' ? (
            exp
          ) : typeof exp === 'object' ? (
            <div>
              {exp.title && <div><strong>المنصب:</strong> {exp.title}</div>}
              {exp.company && <div><strong>الشركة:</strong> {exp.company}</div>}
              {exp.startDate && <div><strong>من:</strong> {exp.startDate}</div>}
              {exp.endDate && <div><strong>إلى:</strong> {exp.endDate}</div>}
              {exp.description && <div><strong>الوصف:</strong> {exp.description}</div>}
            </div>
          ) : (
            String(exp)
          )}
        </div>
      ))
    ) : (
      <div className="text-sm text-gray-500">لا توجد خبرات مسجلة</div>
    )}
  </div>
</div>

                {/* الراتب */}
                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                  <h4 className="font-semibold text-yellow-900 mb-3 flex items-center">
                    <DollarSign className="w-5 h-5 ml-2" />
                    الراتب
                  </h4>
                  <div className="space-y-2 text-sm">
                    <div><span className="font-medium">آخر راتب:</span> {cvAnalysis.salary.lastSalary}</div>
                    <div><span className="font-medium">الراتب المطلوب:</span> {cvAnalysis.salary.requestedSalary}</div>
                  </div>
                </div>

                {/* المهارات */}
                <div className="bg-teal-50 border border-teal-200 rounded-lg p-4">
                  <h4 className="font-semibold text-teal-900 mb-3 flex items-center">
                    <Zap className="w-5 h-5 ml-2" />
                    المهارات
                  </h4>
                  <div className="flex flex-wrap gap-1">
                    {cvAnalysis.skills?.map((skill, index) => (
                      <span key={index} className="px-2 py-1 bg-teal-100 text-teal-800 text-xs rounded-full">
                        {skill}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              {/* أزرار الإجراءات */}
              <div className="flex justify-between items-center pt-6 mt-6 border-t border-gray-200">
                <div className="text-sm text-gray-500">
                  <span className="flex items-center">
                    <FileCheck className="w-4 h-4 ml-1" />
                    تم تحليل السيرة الذاتية بنجاح
                  </span>
                </div>
                
                <div className="flex space-x-3 space-x-reverse">
                  <button
                    onClick={() => setShowCVAnalysis(false)}
                    className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
                  >
                    إغلاق
                  </button>
                  <button
                    onClick={fillDataFromCV}
                    className="bg-purple-600 text-white px-6 py-2 rounded-lg hover:bg-purple-700 flex items-center space-x-2 space-x-reverse"
                  >
                    <Zap className="w-5 h-5" />
                    <span>ملء البيانات تلقائياً</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* نافذة إدارة المؤهلات */}
{showQualificationManager && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto">
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-900 flex items-center">
            <GraduationCap className="w-6 h-6 ml-2" />
            إدارة المؤهلات الدراسية
          </h3>
          <button
            onClick={() => setShowQualificationManager(false)}
            className="text-gray-400 hover:text-gray-600"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
      </div>
      
      <div className="p-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* إدارة مستويات المؤهلات */}
          <div>
            <h4 className="font-medium text-gray-900 mb-4">مستويات المؤهلات</h4>
            
            {/* إضافة مستوى جديد */}
            <div className="bg-blue-50 p-4 rounded-lg mb-4">
              <div className="flex space-x-2 space-x-reverse">
                <input
                  type="text"
                  value={newQualificationLevel}
                  onChange={(e) => setNewQualificationLevel(e.target.value)}
                  className="flex-1 p-2 border border-gray-300 rounded-lg"
                  placeholder="مستوى مؤهل جديد..."
                />
                <button
                  onClick={addQualificationLevel}
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
                >
                  <Plus className="w-4 h-4" />
                </button>
              </div>
            </div>

            {/* قائمة المستويات */}
            <div className="space-y-2">
              {qualificationLevels.map(level => (
                <div key={level.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                  <div className="flex items-center space-x-2 space-x-reverse">
                    <span className="font-medium">{level.name}</span>
                    <label className="flex items-center text-sm text-gray-600">
                      <input
                        type="checkbox"
                        checked={level.hasSpecialization}
                        onChange={() => toggleSpecializationOption(level.id)}
                        className="ml-1"
                      />
                      يحتاج تخصص
                    </label>
                  </div>
                  <button
                    onClick={() => deleteQualificationLevel(level.id)}
                    className="text-red-600 hover:text-red-800"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* إدارة التخصصات */}
          <div>
            <h4 className="font-medium text-gray-900 mb-4">التخصصات حسب المؤهل</h4>
            
            <div className="space-y-4">
              {qualificationLevels
                .filter(level => level.hasSpecialization)
                .map(level => (
                  <div key={level.id} className="bg-gray-50 p-4 rounded-lg">
                    <h5 className="font-medium text-gray-800 mb-2">{level.name}</h5>
                    
                    {/* إضافة تخصص جديد */}
                    <div className="flex space-x-2 space-x-reverse mb-3">
                      <input
                        type="text"
                        value={editingQualification === level.name ? newSpecialization : ''}
                        onChange={(e) => {
                          setEditingQualification(level.name);
                          setNewSpecialization(e.target.value);
                        }}
                        className="flex-1 p-2 border border-gray-300 rounded text-sm"
                        placeholder="تخصص جديد..."
                      />
                      <button
                        onClick={() => addSpecialization(level.name)}
                        className="bg-green-600 text-white px-3 py-2 rounded hover:bg-green-700"
                      >
                        <Plus className="w-3 h-3" />
                      </button>
                    </div>

                    {/* قائمة التخصصات */}
                    <div className="space-y-1">
                      {(qualificationSpecializations[level.name] || []).map((spec, index) => (
                        <div key={index} className="flex items-center justify-between p-2 bg-white rounded text-sm">
                          <span>{spec}</span>
                          <button
                            onClick={() => deleteSpecialization(level.name, index)}
                            className="text-red-600 hover:text-red-800"
                          >
                            <X className="w-3 h-3" />
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>

        <div className="flex justify-end pt-6 mt-6 border-t border-gray-200">
          <button
            onClick={() => setShowQualificationManager(false)}
            className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700"
          >
            حفظ وإغلاق
          </button>
        </div>
      </div>
    </div>
  </div>
)}

      {/* نافذة إضافة مهنة جديدة */}
      {showAddProfession && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">إضافة مهنة جديدة</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">اسم المهنة</label>
                <input
                  type="text"
                  value={newProfession}
                  onChange={(e) => setNewProfession(e.target.value)}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="ادخل اسم المهنة..."
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      addNewProfession();
                    }
                  }}
                />
              </div>
              <div className="flex space-x-3 space-x-reverse">
                <button
                  onClick={addNewProfession}
                  disabled={!newProfession.trim()}
                  className="flex-1 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
                >
                  إضافة
                </button>
                <button
                  onClick={() => {
                    setShowAddProfession(false);
                    setNewProfession('');
                  }}
                  className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
                >
                  إلغاء
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* نافذة تعديل العامل */}
      {editingWorker && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-gray-200">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-semibold text-gray-900">تعديل بيانات العامل</h3>
                <button
                  onClick={() => setEditingWorker(null)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>
            </div>
            
            <div className="p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <h4 className="font-medium text-gray-900 border-b border-gray-200 pb-2">البيانات الأساسية</h4>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">الاسم</label>
                    <input
                      type="text"
                      value={editingWorker.name || ''}
                      onChange={(e) => setEditingWorker(prev => ({ ...prev, name: e.target.value }))}
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">المهنة</label>
                    <select
                      value={editingWorker.profession || ''}
                      onChange={(e) => setEditingWorker(prev => ({ ...prev, profession: e.target.value }))}
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="">اختر المهنة...</option>
                      {availableProfessions.map(prof => (
                        <option key={prof.id} value={prof.name}>{prof.name}</option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">التليفون</label>
                    <input
                      type="text"
                      value={editingWorker.phones?.join(', ') || ''}
                      onChange={(e) => setEditingWorker(prev => ({ 
                        ...prev, 
                        phones: e.target.value.split(',').map(p => p.trim()).filter(p => p) 
                      }))}
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="أرقام منفصلة بفاصلة"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">سنوات الخبرة</label>
                    <input
                      type="number"
                      value={editingWorker.experienceYears || 0}
                      onChange={(e) => setEditingWorker(prev => ({ ...prev, experienceYears: parseInt(e.target.value) || 0 }))}
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      min="0"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">حالة التوظيف</label>
                    <select
                      value={editingWorker.employmentStatus || 'متاح'}
                      onChange={(e) => setEditingWorker(prev => ({ ...prev, employmentStatus: e.target.value }))}
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="متاح">متاح</option>
                      <option value="مشغول">مشغول</option>
                      <option value="غير متاح">غير متاح</option>
                    </select>
                  </div>
                </div>

                <div className="space-y-4">
                  <h4 className="font-medium text-gray-900 border-b border-gray-200 pb-2">البيانات الإضافية</h4>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">المندوب</label>
                    <select
                      value={editingWorker.delegate || ''}
                      onChange={(e) => setEditingWorker(prev => ({ ...prev, delegate: e.target.value }))}
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="">اختر المندوب...</option>
                      {delegates.map(delegate => (
                        <option key={delegate.id} value={delegate.name}>{delegate.name}</option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">المؤهل الدراسي</label>
                    <select
                      value={editingWorker.qualification || ''}
                      onChange={(e) => setEditingWorker(prev => ({ ...prev, qualification: e.target.value }))}
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="">اختر المؤهل...</option>
                      <option value="أمي">أمي</option>
                      <option value="يقرأ ويكتب">يقرأ ويكتب</option>
                      <option value="ابتدائية">ابتدائية</option>
                      <option value="إعدادية">إعدادية</option>
                      <option value="ثانوية">ثانوية</option>
                      <option value="دبلوم">دبلوم</option>
                      <option value="جامعي">جامعي</option>
                      <option value="دراسات عليا">دراسات عليا</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">الراتب المطلوب</label>
                    <input
                      type="text"
                      value={editingWorker.requestedSalary || ''}
                      onChange={(e) => setEditingWorker(prev => ({ ...prev, requestedSalary: e.target.value }))}
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="مثال: 3500 ريال"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">الملاحظات</label>
                    <textarea
                      value={editingWorker.notes || ''}
                      onChange={(e) => setEditingWorker(prev => ({ ...prev, notes: e.target.value }))}
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      rows="3"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">تاريخ آخر تحديث</label>
                    <input
                      type="datetime-local"
                      value={editingWorker.lastUpdate ? new Date(editingWorker.lastUpdate).toISOString().slice(0, 16) : ''}
                      onChange={(e) => setEditingWorker(prev => ({ ...prev, lastUpdate: e.target.value }))}
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                </div>
              </div>

              <div className="flex space-x-3 space-x-reverse pt-6 mt-6 border-t border-gray-200">
                <button
                  onClick={async () => {
                    try {
                      setLoading(true);
                      const { humanResourcesAPI } = getAPIConfig();
                      
                      const response = await fetch(`${humanResourcesAPI}/api/humanresources/workers/${editingWorker.id}`, {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                          ...editingWorker,
                          lastUpdate: new Date()
                        })
                      });

                      if (response.ok) {
                        await loadWorkers();
                        setEditingWorker(null);
                        alert('تم تحديث بيانات العامل بنجاح');
                      } else {
                        throw new Error('فشل في تحديث البيانات');
                      }
                    } catch (error) {
                      console.error('خطأ في تحديث البيانات:', error);
                      alert('فشل في تحديث البيانات');
                    } finally {
                      setLoading(false);
                    }
                  }}
                  disabled={loading}
                  className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center space-x-2 space-x-reverse"
                >
                  {loading ? (
                    <>
                      <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                      <span>جاري الحفظ...</span>
                    </>
                  ) : (
                    <>
                      <Save className="w-5 h-5" />
                      <span>حفظ التعديلات</span>
                    </>
                  )}
                </button>
                <button
                  onClick={() => setEditingWorker(null)}
                  className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
                >
                  إلغاء
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>



      {/* نافذة معاينة العامل */}
{viewingWorker && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto">
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-900">معاينة بيانات العامل</h3>
          <button
            onClick={() => setViewingWorker(null)}
            className="text-gray-400 hover:text-gray-600"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
      </div>
      
      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* البيانات الشخصية */}
          <div className="bg-blue-50 p-4 rounded-lg">
            <h4 className="font-semibold text-blue-900 mb-3">البيانات الشخصية</h4>
            <div className="space-y-2 text-sm">
              <div><span className="font-medium">الاسم:</span> {viewingWorker.name}</div>
              <div><span className="font-medium">سنة الميلاد:</span> {viewingWorker.birthYear || 'غير محدد'}</div>
              <div><span className="font-medium">العمر:</span> {viewingWorker.birthYear ? new Date().getFullYear() - parseInt(viewingWorker.birthYear) + ' سنة' : 'غير محدد'}</div>
              <div><span className="font-medium">الحالة الاجتماعية:</span> {viewingWorker.maritalStatus || 'غير محدد'}</div>
              <div><span className="font-medium">أرقام التليفون:</span> {viewingWorker.phones?.join(' - ') || 'غير محدد'}</div>
            </div>
          </div>

          {/* بيانات العمل */}
          <div className="bg-green-50 p-4 rounded-lg">
            <h4 className="font-semibold text-green-900 mb-3">بيانات العمل</h4>
            <div className="space-y-2 text-sm">
              <div><span className="font-medium">المهنة:</span> {viewingWorker.profession}</div>
              <div><span className="font-medium">وصف المهنة:</span> {viewingWorker.professionDescription || 'غير محدد'}</div>
              <div><span className="font-medium">سنوات الخبرة:</span> {viewingWorker.experienceYears || 0}</div>
              <div><span className="font-medium">حالة التوظيف:</span> {viewingWorker.employmentStatus}</div>
              <div><span className="font-medium">المندوب:</span> {viewingWorker.delegate || 'غير محدد'}</div>
            </div>
          </div>

          {/* الخبرات والمهارات */}
          <div className="bg-purple-50 p-4 rounded-lg md:col-span-2">
            <h4 className="font-semibold text-purple-900 mb-3">الخبرات والمهارات</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
              <div>
                <span className="font-medium text-purple-800">الخبرات السابقة:</span>
                <ul className="mt-2 space-y-1">
                  {viewingWorker.previousExperience?.map((exp, idx) => (
                    <li key={idx} className="text-gray-700">• {exp}</li>
                  ))}
                </ul>
              </div>
              <div>
                <span className="font-medium text-purple-800">المهارات:</span>
                <div className="mt-2 flex flex-wrap gap-1">
                  {viewingWorker.skills?.map((skill, idx) => (
                    <span key={idx} className="px-2 py-1 bg-purple-100 text-purple-700 text-xs rounded-full">
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* الملاحظات */}
          {viewingWorker.notes && (
            <div className="bg-yellow-50 p-4 rounded-lg md:col-span-2">
              <h4 className="font-semibold text-yellow-900 mb-3">الملاحظات</h4>
              <p className="text-sm text-gray-700">{viewingWorker.notes}</p>
            </div>
          )}
        </div>

        <div className="flex justify-end pt-6 mt-6 border-t border-gray-200">
          <button
            onClick={() => {
              setViewingWorker(null);
              openEditModal(viewingWorker);
            }}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 ml-2"
          >
            تعديل البيانات
          </button>
          <button
            onClick={() => setViewingWorker(null)}
            className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
          >
            إغلاق
          </button>
        </div>
      </div>
    </div>
  </div>
)}




{/* نافذة تأكيد الحذف */}
{showDeleteConfirm && workerToDelete && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
      <div className="flex items-center mb-4">
        <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center ml-3">
          <AlertCircle className="w-6 h-6 text-red-600" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-gray-900">تأكيد الحذف</h3>
          <p className="text-sm text-gray-600">هذا الإجراء لا يمكن التراجع عنه</p>
        </div>
      </div>
      
      <p className="text-gray-700 mb-6">
        هل أنت متأكد من حذف العامل <span className="font-semibold text-red-600">"{workerToDelete.name}"</span>؟
      </p>
      
      <div className="flex space-x-3 space-x-reverse">
        <button
          onClick={confirmDelete}
          disabled={loading}
          className="flex-1 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 disabled:bg-gray-400"
        >
          {loading ? 'جاري الحذف...' : 'نعم، احذف'}
        </button>
        <button
          onClick={() => {
            setShowDeleteConfirm(false);
            setWorkerToDelete(null);
          }}
          className="flex-1 bg-gray-100 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-200"
        >
          إلغاء
        </button>
      </div>
    </div>
  </div>
)}

    {/* شاشة التحميل */}
    {loading && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-6 flex items-center space-x-3 space-x-reverse">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          <span className="text-gray-900">جاري المعالجة...</span>
        </div>
      </div>
    )}


     {/* المودال الجديد - ضعه هنا */}
      {showImagePreview && selectedImage && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
          onClick={() => {
            setShowImagePreview(false);
            setSelectedImage(null);
          }}
        >
          <div className="relative max-w-4xl max-h-[90vh] bg-white rounded-xl shadow-2xl overflow-hidden">
            <img 
              src={selectedImage} 
              alt="معاينة الصورة"
              className="max-w-full max-h-[85vh] object-contain p-2"
            />
            <button
              className="absolute top-4 right-4 bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition duration-200 transform hover:scale-110"
              onClick={(e) => {
                e.stopPropagation();
                setShowImagePreview(false);
                setSelectedImage(null);
              }}
            >
              <X size={24} />
            </button>
            <div className="absolute bottom-4 left-4 right-4 flex justify-center space-x-2 space-x-reverse">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  if (newWorker.photo) {
                    downloadFile(newWorker.photo, 'صورة');
                  }
                }}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center space-x-2 space-x-reverse"
              >
                <Download className="w-4 h-4" />
                <span>تحميل الصورة</span>
              </button>
            </div>
          </div>
        </div>
      )}


  </div>
);
};

export default HumanResourcesManagement;